import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { BellRing, Save } from "lucide-react";

// Fallback Discord channel pinged when a new host's DMs are closed.
export default function HostNoticeSettings() {
  const [channels, setChannels] = useState([]);
  const [value, setValue] = useState("");
  const [saved, setSaved] = useState("");
  const [intent, setIntent] = useState(null);

  useEffect(() => {
    api.get("/admin/site-settings").then(({ data }) => { setValue(data.host_notice_channel_id || ""); setSaved(data.host_notice_channel_id || ""); }).catch(() => {});
    api.get("/admin/discord/channels").then(({ data }) => setChannels(data.text || [])).catch(() => {});
    api.get("/admin/host-onboarding").then(({ data }) => setIntent(data.members_intent)).catch(() => {});
  }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/admin/site-settings", { host_notice_channel_id: value });
      setSaved(data.host_notice_channel_id || "");
      toast.success(value ? "Host notice fallback channel saved" : "Fallback channel cleared");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="surface-card p-6 space-y-4" data-testid="host-notice-settings">
      <div className="flex items-start gap-3">
        <BellRing size={20} className="text-[var(--ff-red)] shrink-0 mt-1" />
        <div>
          <div className="label-eyebrow mb-1">▮ HOST ONBOARDING NOTICES</div>
          <p className="text-sm text-[var(--ff-text-dim)] max-w-2xl">
            When someone gets the Host role (on the site or directly in Discord) the bot DMs them an urgent notice to read the policies. If their DMs are closed, it pings them in this channel instead.
          </p>
          <div className={`font-mono-ui text-[0.65rem] uppercase tracking-[0.15em] mt-2 ${intent === false ? "text-yellow-300" : "text-emerald-400"}`} data-testid="host-notice-intent">
            {intent === false ? "Server Members Intent is OFF in the Discord Developer Portal — only site grants trigger notices" : intent ? "Server Members Intent ON — Discord-side grants detected" : "Checking bot…"}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <select value={value} onChange={(e) => setValue(e.target.value)} className="px-3 py-2 text-sm min-w-[260px]" data-testid="host-notice-channel-select">
          <option value="">— No fallback channel —</option>
          {channels.map((c) => <option key={c.id} value={c.id}>#{c.name}</option>)}
        </select>
        <button onClick={save} disabled={value === saved} className="btn-primary text-xs disabled:opacity-40" data-testid="host-notice-channel-save"><Save size={12} /> Save</button>
      </div>
    </div>
  );
}
